import React, {useEffect, useRef, useState} from 'react';
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {useTranslate} from "../../../system/useTranslate";
import Icon from "../../../system/components/icon";
import BoxHeader from "../../components/box-header";
import Span from "../../../system/components/span";
import {InputText} from "primereact/inputtext";
import {MultiSelect} from "primereact/multiselect";
import {useSelector} from "react-redux";
import Avatar from "../../../system/components/avatar";
import {Avatar as PrimeAvatar}  from "primereact/avatar";
import InputLabel from "../../../system/components/input-label";
import SelectMembers from "../../tasks/components/select-members";
import PrimeDatePicker from "../../../system/components/prime-date-picker";
import {Divider} from "primereact/divider";
import {useUpdateEffect} from "primereact/hooks";
import {OverlayPanel} from "primereact/overlaypanel";
import SelectIcon from "../../tasks/components/select-icon";
import {Dropdown} from "primereact/dropdown";
import {Tooltip} from "primereact/tooltip";
import {ColorPicker} from "primereact/colorpicker";
import {InputSwitch} from "primereact/inputswitch";
import {Checkbox} from "primereact/checkbox";
import {DataView} from "primereact/dataview";
import MultiSelectMembers from "../../tasks/components/multi-select-members";
import SelectMember from "../../tasks/components/select-member";
import AvatarGroup from "../../../system/components/avatar-group";
import {Message} from "primereact/message";
import {normalizeProjectMemberSelections} from "../project-member-roles";

function CreateProjectDialog({visible, setVisible, projectData, initialData, onSubmit, mobile = false, submitting = false, error = ""}) {
    const translate = useTranslate();
    const [newProjectData, setNewProjectData] = useState();
    const [validationError, setValidationError] = useState("");
    const {config, workspaceMembershipData} = useSelector((state) => state.app);

    useUpdateEffect(() => {
        if (visible){
            setValidationError("");
            if (!projectData){
                setNewProjectData({
                    owner: workspaceMembershipData,
                    creatorUser: workspaceMembershipData,
                    ...(initialData || {}),
                });
            }
        }
    }, [visible]);

    const modifyProjectMembers = (data)=>{
        setNewProjectData({...newProjectData, members:data?.members});
    }

    const submit = async ()=>{
        if (!String(newProjectData?.title || "").trim()) {
            setValidationError(translate("mobile.quick-create.project-title-required"));
            return;
        }
        if (!newProjectData?.dueDate) {
            setValidationError(translate("mobile.quick-create.project-due-date-required"));
            return;
        }
        setValidationError("");
        let _newProjectData = {...newProjectData};
        if (_newProjectData?.members) {
            _newProjectData = {
                ..._newProjectData,
                members: normalizeProjectMemberSelections(_newProjectData.members),
            };
        }
        if (_newProjectData?.parentProjects)_newProjectData = {..._newProjectData, parentProjects:_newProjectData?.parentProjects.map(p=>p.id)};
        if (_newProjectData?.goals)_newProjectData = {..._newProjectData, goals:_newProjectData?.goals.map(g=>g.id)};
        if (_newProjectData?.owner) _newProjectData = {..._newProjectData, owner: _newProjectData?.owner?.id};
        if (_newProjectData?.creatorUser)_newProjectData = {..._newProjectData, creatorUser: _newProjectData?.creatorUser?.id};
        if (_newProjectData?.team)_newProjectData = {..._newProjectData, team: _newProjectData?.team?.id};
        await onSubmit?.({value: _newProjectData, payload:newProjectData})
    }

    // useUpdateEffect(()=>{
    //     console.log(newProjectData)
    // },[newProjectData])

    return (
        <Dialog pt={{footer:()=>({className:"p-0 border-round-bottom-2xl"}),content:()=>({className:"p-0 h-full"})}} header={<Header projectData={projectData}/>} contentClassName="p-4" headerClassName="border-round-top-2xl border-bottom-1 border-300 pb-3 pt-3" footer={<Footer setVisible={setVisible} onSubmit={submit} submitting={submitting}/>} className={mobile ? "shabnam-font rtl w-full md:w-6 mx-2 md:mx-0 border-round-bottom-2xl" : "rtl w-6 border-round-bottom-2xl"} visible={visible} onHide={()=>{if (!submitting) setVisible(false)}}>
            <div className="flex flex-column gap-3">
                {(validationError || error) && <Message className="text-xs" severity="error" text={validationError || error}/>}
                <InputText placeholder={translate("project-name-placeholder")} className="flex-1 border-none shadow-none text-xl" value={newProjectData?.title||projectData?.title} onChange={(e)=>{setNewProjectData({...newProjectData, title:e.target.value})}}/>
                <div className="flex flex-wrap gap-2 w-full align-items-center">
                    <InputLabel className="w-6" label={translate("project-owner")}>
                        <SelectMember primeDropdown={true} selectedMember={newProjectData?.owner || projectData?.owner} onChange={(membership) => {setNewProjectData({...newProjectData, owner: membership})}} hideLabel={false} members={workspaceMembershipData?.workspace?.workspace_memberships || []}/>
                    </InputLabel>
                    <InputLabel className="flex-1" label={translate("project-members")}>
                        <ProjectMembers projectData={projectData} onChange={(e)=>{modifyProjectMembers(e)}}/>
                    </InputLabel>
                </div>
                <div className="flex flex-wrap gap-2 w-full align-items-center">
                    <InputLabel require className="flex-1" label={translate("project-due-date")}>
                        <PrimeDatePicker inputClassName="w-full" value={new Date(newProjectData?.dueDate||projectData?.dueDate).getTime()/1000} onChange={(e)=>{setNewProjectData({...newProjectData, dueDate:new Date(e.value*1000)})}}/>
                    </InputLabel>

                    <InputLabel className="flex-1" label={translate("responsible-team")}>
                        <SelectTeam options={workspaceMembershipData?.workspace?.teams} value={newProjectData?.team || projectData?.team} onChange={(e) => {setNewProjectData({...newProjectData, team: e})}}/>
                    </InputLabel>
                </div>

                <InputLabel className="flex-1" label={translate("parent-project")}>
                    <SelectProjects projectData={projectData} onChange={(e) => {setNewProjectData({...newProjectData, parentProjects: e})}}/>
                </InputLabel>

                <InputLabel className="flex-1" label={translate("goals")}>
                    <SelectGoals projectData={projectData} onChange={(e) => {setNewProjectData({...newProjectData, goals: e})}}/>
                </InputLabel>

                {/*<InputLabel className="flex-1" inputType="TEXTAREA" label={translate("strategic-hypothesis")} value={newProjectData?.hypothesis||projectData?.hypothesis} onChange={(e)=>{setNewProjectData({...newProjectData, hypothesis:e.target.value})}}/>*/}
                <InputLabel className="flex-1" inputType="RICHTEXT" label={translate("project-description")} value={newProjectData?.description||projectData?.description} onChange={(e)=>{setNewProjectData({...newProjectData, description:e.target.value})}}/>

                <InputLabel>
                    <IconColorPicker value={newProjectData?.color_icon||projectData?.color_icon} onChange={(e)=>{setNewProjectData({...newProjectData, color_icon:e.value})}}/>
                </InputLabel>

                {/*<InputLabel label={translate("project-members")}>*/}
                {/*    <SelectMembers selectedMembers={newProjectData?.members||projectData?.members} members={workspaceMembershipData?.workspace.workspace_memberships.map(e=>e.member)} onChange={(e)=>{setNewProjectData({...newProjectData, members:e.members})}}/>*/}
                {/*</InputLabel>*/}

                <div className="flex flex-wrap gap-2">
                    <InputLabel className="flex-1" inputType="TEXT" label={translate("total-time")} value={newProjectData?.totalTime||projectData?.totalTime} onChange={(e)=>{setNewProjectData({...newProjectData, totalTime:e.target.value})}}/>
                    <InputLabel className="flex-1" inputType="TEXT" label={translate("total-budget")} value={newProjectData?.totalBudget||projectData?.totalBudget} onChange={(e)=>{setNewProjectData({...newProjectData, totalBudget:e.target.value})}}/>
                </div>
            </div>
        </Dialog>
    );
}

function IconColorPicker({value, onChange}) {

    const ref = useRef();
    const [colorIcon, setColorIcon] = useState(value)
    const colors = ["red","blue","purple","green","orange"]
    const colorPickerRef = useRef();
    useUpdateEffect(()=>{
        onChange?.({value:colorIcon});
    },[colorIcon])

    return(
        <div className="flex align-items-center gap-2">
            <PrimeAvatar onClick={(e)=>{ref.current.toggle(e)}} shape="circle" size="large" className="border-2 border-dashed border-300" icon={<Icon icon={value?.icon||"mi mi:image"}/>}/>
            <OverlayPanel ref={ref}>
                <SelectIcon onChange={(e)=>{setColorIcon({...colorIcon, icon:e});ref.current.hide()}}/>
            </OverlayPanel>
            <Divider className="m-1" layout="vertical"/>
            {colors.map(c=><PrimeAvatar onClick={()=>{setColorIcon({...colorIcon, color:c})}} icon={c===value?.color&&<Icon icon="mi mi:check" className="text-white"/>} className="cursor-pointer border-2 border-white shadow-2" shape="circle" size="normal" style={{backgroundColor:c}}/>)}
            <PrimeAvatar style={{backgroundColor:colorIcon?.color}} shape="circle" onClick={(e)=>{colorPickerRef.current.toggle(e)}} className="border-2 border-dashed border-300 cursor-pointer" icon={<Icon icon="mi mi:add" className="text-400"/>}/>
            <OverlayPanel pt={{root:()=>({className:"p-0"}),content:()=>({className:"p-1"})}} ref={colorPickerRef}>
                <ColorPicker inline pt={{input:()=>({className:"border-400",style:{borderRadius:'20px', border:"dashed 2px"}})}} value={colorIcon?.color} onChange={(e) => {setColorIcon({...colorIcon, color:`#${e.value}`});}} />
            </OverlayPanel>
        </div>
    )
}

function SelectTeam({value, options, onChange}) {
    const translate = useTranslate();

    // let _options = [{name: translate("select-team"), id: 0}, ...options];

    const ItemTemplate = (data, props) => {
        return (
            <div>
                {data?translate(data?.name):props.placeholder}
            </div>
        )
    }

    return (
        <Dropdown placeholder={translate("select-team-placeholder")} options={options} value={value} valueTemplate={ItemTemplate} onChange={(e) => {onChange?.(e.value)}} itemTemplate={ItemTemplate}/>
    )
}

function Header({projectData}) {
    const translate = useTranslate();
    return(
        <div className="flex flex-column">
            <span className="text-lg">{translate(projectData?"project-setting":"create-project")}</span>
            <span className="text-xs text-400">{projectData?.title}</span>
        </div>
    )
}

function Footer({setVisible, onSubmit, submitting}) {
    const translate = useTranslate();
    return(
        <div className="flex flex-row-reverse align-items-center gap-2 justify-content-start p-3 surface-50 border-round-bottom-2xl border-top-1 border-300">
            <Button icon={<Icon icon="mi mi:save" className="text-lg"/>} className="text-xs flex gap-2 border-round-lg p-2" label={translate("save-changes")} loading={submitting} disabled={submitting} onClick={onSubmit}/>
            <Button className="text-xs p-button-secondary p-button-outlined border-round-lg p-2" label={translate("cancel")} disabled={submitting} onClick={()=>{setVisible(false)}}/>
        </div>
    )
}

function ProjectMembers({projectData, onChange}) {
    const {config, workspaceMembershipData} = useSelector((state) => state.app);
    const translate = useTranslate();
    const [newMembersData, setNewMembersData] = useState();


    useEffect(() => {
        setNewMembersData(projectData?.members);
    }, []);


    useUpdateEffect(()=>{
        if (newMembersData){
            onChange?.({members: normalizeProjectMemberSelections(newMembersData)});
        }
    },[newMembersData])


    //
    // const modifyMembers = (data)=>{
    //     if (data?.status==="added"){
    //         setNewMembersData([...newMembersData??[], data.member])
    //     }
    //     if (data?.status==="removed"){
    //         setNewMembersData([...newMembersData??[]].filter(m=>m.id!==data.member.id))
    //     }
    // }
    const ItemTemplate = (data)=>{
        return data?(
            <div className="w-fit flex align-items-center gap-1 text-xs">
                <Avatar memberData={data?.member}/>
                {data?.member.fullname}
            </div>
        ):(
            <div className="p-2">{translate("select-members-placeholder")}</div>
        )
    }
    // const SelectedItemTemplate = (data)=>{
    //     return (
    //         <div className="w-fit flex align-items-center gap-1 text-xs p-1 surface-100 border-round-2xl">
    //             <Avatar  memberData={data?.member}/>
    //             {/*{data?.member.fullname}*/}
    //         </div>
    //     )
    // }

    return(
        <div onClick={(e)=>{}} className="border-round border-1 border-300 flex justify-content-between pr-2">
            <AvatarGroup>
                {newMembersData?.map(m=>(<Avatar memberData={m.member}/>))}
            </AvatarGroup>
            <MultiSelect selectedItemsLabel={`${newMembersData?.length} ${translate("member")}`}  filterTemplate={(options)=>(<InputText placeholder={translate("search-members-placeholder")} onChange={options.filterOptions.filter} className="p-2 w-full text-xs"/>)} filter filterBy="member.fullname" placeholder={translate("select-members-placeholder")} pt={{root:()=>({className:"w-full border-none shadow-none"}),label:()=>({className:"hidden"}) ,labelContainer:()=>({className:"align-items-center flex pr-2"}) ,trigger:()=>({className:"p-3"}) , filterInput:()=>({className:"p-0"}), header:()=>({className:"p-2 flex-row-reverse"}), item:()=>({className:"flex-row-reverse justify-content-between p-2"})}} panelClassName="rtl" onChange={(e)=>{setNewMembersData(e.value)}}  itemTemplate={ItemTemplate} options={workspaceMembershipData?.workspace?.workspace_memberships} value={newMembersData||[]}/>
        </div>
        // <div className="flex flex-column gap-2" >
        //     <OverlayPanel pt={{root:()=>({className:"p-0 rtl"}),content:()=>({className:"p-0"})}} ref={memberRef}>
        //         <MultiSelectMembers onChange={(e)=>{modifyMembers(e)}} options={workspaceMembershipData?.workspace?.workspace_memberships} value={newMembersData||[]}/>
        //     </OverlayPanel>
        //     <div className="border-round border-1 border-300 p-2 flex justify-content-between">
        //         <AvatarGroup className="ltr">
        //             {newMembersData?.map(m=>(<Avatar memberData={m.member}/>))}
        //         </AvatarGroup>
        //         <Icon icon="pi pi-chevron-down text-sm p-2" className="p-2" onClick={(e)=>{memberRef.current.toggle(e)}} />
        //     </div>
        // </div>
    )
}


function SelectProjects({projectData, onChange}) {
    const {config, workspaceMembershipData} = useSelector((state) => state.app);
    const translate = useTranslate();
    const [newParentProjectsData, setNewParentProjectsData] = useState();


    useEffect(() => {
        setNewParentProjectsData(projectData?.parentProjects);
    }, []);


    useUpdateEffect(()=>{
        if (newParentProjectsData){
            onChange?.(newParentProjectsData);
        }
    },[newParentProjectsData])


    //
    // const modifyMembers = (data)=>{
    //     if (data?.status==="added"){
    //         setNewMembersData([...newMembersData??[], data.member])
    //     }
    //     if (data?.status==="removed"){
    //         setNewMembersData([...newMembersData??[]].filter(m=>m.id!==data.member.id))
    //     }
    // }
    const ItemTemplate = (data)=>{
        return data?(
            <div className="w-fit flex align-items-center gap-1 text-xs">
                {data?.title}
            </div>
        ):(
            <div className="p-2">{translate("select-projects-placeholder")}</div>
        )
    }
    const SelectedItemTemplate = (data)=>{
        return (
            <div className="w-fit flex align-items-center gap-1 text-xs p-1 px-2 surface-100 border-round-2xl">
                {/*<Avatar  memberData={data?.member}/>*/}
                {data?.title}
            </div>
        )
    }

    return(
        <div onClick={(e)=>{}} className="border-round border-1 border-300 flex justify-content-between pr-2">
            <MultiSelect selectedItemTemplate={SelectedItemTemplate}  filterTemplate={(options)=>(<InputText placeholder={translate("search-projects-placeholder")} onChange={options.filterOptions.filter} className="p-2 w-full text-xs"/>)} filter filterBy="title" placeholder={translate("select-projects-placeholder")} pt={{root:()=>({className:"w-full border-none shadow-none"}),label:()=>({className:"flex gap-1"}) ,labelContainer:()=>({className:"align-items-center flex pr-2"}) ,trigger:()=>({className:"p-3"}) , filterInput:()=>({className:"p-0"}), header:()=>({className:"p-2 flex-row-reverse"}), item:()=>({className:"flex-row-reverse justify-content-between p-2"})}} panelClassName="rtl" onChange={(e)=>{setNewParentProjectsData(e.value)}}  itemTemplate={ItemTemplate} options={workspaceMembershipData?.workspace?.projects} value={newParentProjectsData||[]}/>
        </div>
        // <div className="flex flex-column gap-2" >
        //     <OverlayPanel pt={{root:()=>({className:"p-0 rtl"}),content:()=>({className:"p-0"})}} ref={memberRef}>
        //         <MultiSelectMembers onChange={(e)=>{modifyMembers(e)}} options={workspaceMembershipData?.workspace?.workspace_memberships} value={newMembersData||[]}/>
        //     </OverlayPanel>
        //     <div className="border-round border-1 border-300 p-2 flex justify-content-between">
        //         <AvatarGroup className="ltr">
        //             {newMembersData?.map(m=>(<Avatar memberData={m.member}/>))}
        //         </AvatarGroup>
        //         <Icon icon="pi pi-chevron-down text-sm p-2" className="p-2" onClick={(e)=>{memberRef.current.toggle(e)}} />
        //     </div>
        // </div>
    )
}


function SelectGoals({projectData, onChange}) {
    const {config, workspaceMembershipData} = useSelector((state) => state.app);
    const translate = useTranslate();
    const [newGoalsData, setNewGoalsData] = useState();


    useEffect(() => {
        setNewGoalsData(projectData?.goals);
    }, []);


    useUpdateEffect(()=>{
        if (newGoalsData){
            onChange?.(newGoalsData);
        }
    },[newGoalsData])


    //
    // const modifyMembers = (data)=>{
    //     if (data?.status==="added"){
    //         setNewMembersData([...newMembersData??[], data.member])
    //     }
    //     if (data?.status==="removed"){
    //         setNewMembersData([...newMembersData??[]].filter(m=>m.id!==data.member.id))
    //     }
    // }
    const ItemTemplate = (data)=>{
        return data?(
            <div className="w-fit flex align-items-center gap-1 text-xs">
                {data?.title}
            </div>
        ):(
            <div className="p-2">{translate("select-projects-placeholder")}</div>
        )
    }
    const SelectedItemTemplate = (data)=>{
        return (
            <div className="w-fit flex align-items-center gap-1 text-xs p-1 px-2 surface-100 border-round-2xl">
                {/*<Avatar  memberData={data?.member}/>*/}
                {data?.title}
            </div>
        )
    }

    return(
        <div onClick={(e)=>{}} className="border-round border-1 border-300 flex justify-content-between pr-2">
            <MultiSelect selectedItemTemplate={SelectedItemTemplate}  filterTemplate={(options)=>(<InputText placeholder={translate("search-goals-placeholder")} onChange={options.filterOptions.filter} className="p-2 w-full text-xs"/>)} filter filterBy="title" placeholder={translate("select-goals-placeholder")} pt={{root:()=>({className:"w-full border-none shadow-none"}),label:()=>({className:"flex gap-1"}) ,labelContainer:()=>({className:"align-items-center flex pr-2"}) ,trigger:()=>({className:"p-3"}) , filterInput:()=>({className:"p-0"}), header:()=>({className:"p-2 flex-row-reverse"}), item:()=>({className:"flex-row-reverse justify-content-between p-2"})}} panelClassName="rtl" onChange={(e)=>{setNewGoalsData(e.value)}}  itemTemplate={ItemTemplate} options={workspaceMembershipData?.workspace?.goals} value={newGoalsData||[]}/>
        </div>
        // <div className="flex flex-column gap-2" >
        //     <OverlayPanel pt={{root:()=>({className:"p-0 rtl"}),content:()=>({className:"p-0"})}} ref={memberRef}>
        //         <MultiSelectMembers onChange={(e)=>{modifyMembers(e)}} options={workspaceMembershipData?.workspace?.workspace_memberships} value={newMembersData||[]}/>
        //     </OverlayPanel>
        //     <div className="border-round border-1 border-300 p-2 flex justify-content-between">
        //         <AvatarGroup className="ltr">
        //             {newMembersData?.map(m=>(<Avatar memberData={m.member}/>))}
        //         </AvatarGroup>
        //         <Icon icon="pi pi-chevron-down text-sm p-2" className="p-2" onClick={(e)=>{memberRef.current.toggle(e)}} />
        //     </div>
        // </div>
    )
}


export default CreateProjectDialog;
